import Navbar from "./Navbar/NavBar";
import {Button, Card, Col, Layout, Row, Table, Typography} from "antd";
import React, {useState} from "react";
import {AMINO_ACID_LIST} from "./Util";
import {DownloadOutlined} from "@ant-design/icons";


function Extra() {
    const getDataSourceObjects = (startIndex, endIndex) => {
        return AMINO_ACID_LIST.map((amino_acid, index) => {
            if (index >= startIndex && index < endIndex) {
                return {
                    amino_acid: amino_acid,
                    key: index,
                    media: <div style={{display: 'flex', flexDirection: "column", gap: "0.5em"}}>
                        <Button type="primary" onClick={() => {
                            setVideoUrl(null)
                            setAnimationUrl(`${process.env.PUBLIC_URL}/extra/gifs/${amino_acid}_animation.gif`)
                            setDownloadUrl(`${process.env.PUBLIC_URL}/extra/gifs/${amino_acid}_animation.gif`)
                        }}>Animation </Button>

                        <Button type="primary" style={{backgroundColor: "green"}} onClick={() => {
                            setAnimationUrl(null)
                            setVideoUrl(`${process.env.PUBLIC_URL}/extra/movies/${amino_acid}_animation.mp4`)
                            setDownloadUrl(`${process.env.PUBLIC_URL}/extra/movies/${amino_acid}_animation.mp4`)
                        }}>Movie </Button>
                    </div>
                }
            }
            return null;
        }).filter(value => value !== null);
    }
    const dataSource1 = getDataSourceObjects(0, 10);
    const dataSource2 = getDataSourceObjects(10, 20);

    const [animationUrl, setAnimationUrl] = useState(null);
    const [videoUrl, setVideoUrl] = useState(null);
    const [downloadUrl, setDownloadUrl] = useState(null);


    const columns = [
        {
            title: 'Amino acid',
            dataIndex: 'amino_acid',
            key: 'amino_acid',
            align: 'center'
        },
        {
            title: 'Click to view',
            dataIndex: 'media',
            key: 'media',
        }
    ];
    return (<Layout style={{backgroundColor: '#FFFFFF', minHeight: '100dvh'}}>
            <div style={{position: 'sticky', top: 0, zIndex: 10000}}>
                <Navbar/>
            </div>
            <Layout.Content
                style={{
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: '#FFFFFF',
                    gap: 40,
                    lineHeight: "2em",
                    paddingLeft: '2vw',
                    paddingTop: '2vh',
                    paddingBottom: '2vh'
                }}>

                <Row style={{justifyContent: "left"}}>
                    <Col span={1}/>
                    <Col span={23}>
                        <Card bordered={true} style={{width: "fit-content", paddingRight: '5vw'}}>
                            <ul>
                                <li><a href={"#conditioned_distributions"} style={{display: "block"}}><h3>Conditional
                                    distribution ⟨φ, ψ⟩ |ω</h3></a></li>
                            </ul>
                        </Card>
                    </Col>
                </Row>


                <Row id={"conditioned_distributions"}
                     style={{
                         scrollMarginTop: '10vh',
                         scrollSnapMarginTop: '10vh',
                         display: "flex",
                         justifyContent: "stretch"
                     }}>


                    <Col span={24}>
                        <Typography.Title level={3}> Conditional distribution ⟨φ, ψ⟩ |ω </Typography.Title>
                        Contains 20 animations and movies for the canonical amino acids that show the conditional
                        distribution ⟨φ, ψ⟩ |ω, for varying ω angles.
                        Click any <Button type="primary">Animation </Button> or <Button type="primary"
                                                                                        style={{backgroundColor: "green"}}>Movie </Button> to
                        view on the browser.
                    </Col>

                </Row>

                <Row>
                    <Col span={12}>

                        <Row style={{display: 'flex', gap: '2.0em'}}>
                            <Col span={6} style={{
                                display: "flex",
                                flexWrap: "wrap",
                                flexDirection: "row",

                            }}>
                                <Table dataSource={dataSource1} columns={columns}
                                       sticky
                                       bordered
                                       loading={false}
                                       size="small"
                                       pagination={false}
                                />
                            </Col>

                            <Col span={6} style={{
                                display: "flex",
                                flexWrap: "wrap",
                                flexDirection: "row"
                            }}>
                                <Table dataSource={dataSource2} columns={columns}
                                       sticky
                                       bordered
                                       loading={false}
                                       size="small"
                                       pagination={false}
                                /></Col>
                        </Row>
                    </Col>

                    <Col span={10} style={{display: "flex", alignItems: "center"}}>
                        <div style={{display: "flex", flexDirection: "column"}}>
                            <div hidden={animationUrl == null && videoUrl == null}>
                                Along with the conditional distribution of ⟨φ, ψ⟩ given a specific value of ω (shown as
                                compression contour lines),
                                the marginal probability of observing that value of ω is also displayed on top of the
                                animated figure displayed below.
                            </div>

                            <div>
                                <img src={animationUrl} hidden={animationUrl == null} alt={"Conditioned distribution"}/>
                                <video controls autoPlay={true} src={videoUrl} hidden={videoUrl == null}></video>
                                <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
                                    <p>
                                        <a href={downloadUrl} download hidden={downloadUrl == null}><DownloadOutlined/> Download Media </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Layout.Content>
            <Layout.Footer style={{width: '100%', textAlign: 'right', zIndex: 1000, backgroundColor: "#58B2DC"}}><b>About
                <a href="https://lcb.infotech.monash.edu/phisical/" target="_blank" rel="noreferrer"
                   style={{color: "#1402f6"}}> 𝜙𝛹𝜒al</a> |
                <a href="https://lcb.infotech.monash.edu/" target="_blank" rel="noreferrer"
                   style={{color: "#1402f6"}}> LCB Home</a> |v1.0.0 </b>
            </Layout.Footer>
        </Layout>
    );
}

export default Extra;